module.exports = __webpack_public_path__ + "static/media/PATCHED.f5a413a0.svg";